import { Controller } from "stimulus"
import { trigger, validateEmail, lang } from "../../js/utils"
export default class extends Controller {
  static get targets() {
    return ["form"]
  }

  connect() {
    this.formTarget.submit = this.submit
    setTimeout(() => {}, 500)
  }

  async submit(e) {
    if (e) e.preventDefault()
    const formData = new FormData(this.formTarget)

    if (validateEmail(this.formTarget.email.value)) {
      Array.from(this.formTarget.elements).forEach((el) => {
        el.disabled = true
      })

      const res = await fetch("/.netlify/functions/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        body: JSON.stringify(Object.fromEntries(formData)),
      })

      Array.from(this.formTarget.elements).forEach((el) => {
        el.disabled = false
      })

      if (res.status == 202) {
        trigger("snackbar:show", { message: lang("contact_form").thankyou, autoHide: true })
        this.formTarget.reset()
      } else {
        trigger("snackbar:show", { message: lang("contact_form").error, autoHide: true, status: "error" })
      }
    } else {
      trigger("snackbar:show", { message: lang("contact_form").error_email, autoHide: true, status: "error" })
      this.formTarget.email.focus()
    }
  }
}
